import React from 'react';
import PropTypes from 'prop-types';
import { StreamUpload as RealStreamUpload } from '../LazyLoader';


const StreamUpload = (props) => {
    return (
        <React.Suspense fallback={null}>
            <RealStreamUpload {...props}/>
        </React.Suspense>
    );
};

StreamUpload.propTypes = {
    /**
     * Идентификатор компонента для Dash Callbacks
     */
    id: PropTypes.string,

    /**
     * Конфигурация сервера
     */
    server_config: PropTypes.shape({
        /**
         * URL адрес до конечно точки API загрузки.
         * Точка должна поддеживать методы process, load
         * [Подробнее](https://pqina.nl/filepond/docs/api/server/#url)
         */
        url: PropTypes.string.isRequired,
        /**
         * добавлять ли в запрос на загрузку куки
         */
        with_credentials: PropTypes.bool,
        /**
         * дополнительные заголовки, например Authorization
         */
        headers: PropTypes.object,
    }),

    /**
     * Наименование элемента формы, которое отправляется на сервер как связка имя/значение
     */
    name: PropTypes.string,

    /**
     * Загруженные на сервер файлы. Содержат список идентификаторов файлов - Array[serverId]
     */
    initial_files: PropTypes.arrayOf(PropTypes.string),

    /**
     * Разрешить загрузку нескольких файлов
     */
    multiple: PropTypes.bool,

    /**
     * Автоматически загружать файлы при добавлении
     */
    auto_upload: PropTypes.bool,

    /**
     * Файлы загружены. Истина при пустой форме
     */
    is_complete: PropTypes.bool,

    /**
     * Список аттрибутов загруженных файлов
     */
    uploaded_files: PropTypes.arrayOf(PropTypes.shape({
        /**
         * идентификатор файла, возвращаемый сервером
         */
        server_id: PropTypes.string,
        /**
         * наименование файла вместе с расширением
         */
        file_name: PropTypes.string,
        /**
         * размер файла в байтах
         */
        file_size: PropTypes.number,
    })),

    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: PropTypes.func
};

StreamUpload.defaultProps = {
    name: "file",
    initial_files: [],
    multiple: false,
    auto_upload: false,
};

export default StreamUpload;
export const propTypes = StreamUpload.propTypes;
export const defaultProps = StreamUpload.defaultProps;
